import { ArrowUpRight } from "@phosphor-icons/react";
import { FadeIn } from "../FadeIn";

const MARKETS = [
  { name: "GunBroker", tag: "Auction Listings", url: "https://www.gunbroker.com/user/appguns" },
  { name: "eBay", tag: "Parts, Optics & Accessories", url: "https://ebay.io/m/v4yY3J" },
  { name: "TacSwap", tag: "Guns, Gear & More", url: "https://tacswap.com/user/appguns" },
  { name: "Infinite Armory", tag: "Drop Culture Swag & More", url: "https://infinitearmory.com/vendor/appguns/" },
  { name: "Facebook", tag: "Our not so regular updates", url: "https://facebook.com/appgunsffl" },
];

const SPANS = ["md:col-span-3", "md:col-span-3", "md:col-span-2", "md:col-span-2", "md:col-span-2"];

export const Marketplaces = () => (
  <section id="marketplaces" data-testid="marketplaces-section" className="px-6 md:px-12 py-24 md:py-36 border-t border-white/10">
    <FadeIn>
      <p className="text-violet-400 text-xs tracking-[0.35em] uppercase mb-4">Marketplaces</p>
      <h2 className="font-display uppercase tracking-tighter text-5xl md:text-7xl leading-[0.95] mb-6">
        Find us <span className="text-outline-purple">everywhere</span>
      </h2>
      <p className="text-white/60 text-base md:text-lg max-w-2xl mb-16">
        We list inventory across five platforms. Follow a profile, watch the listings,
        and grab it before it's gone.
      </p>
    </FadeIn>

    <div className="grid md:grid-cols-6 gap-8">
      {MARKETS.map((m, i) => (
        <FadeIn key={m.name} delay={i * 0.08} className={SPANS[i]}>
          <a
            href={m.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`marketplace-link-${m.name.toLowerCase().replace(/\s+/g, "-")}`}
            className="group block border border-white/10 p-8 h-full hover:border-primary transition-colors"
          >
            <div className="flex items-start justify-between">
              <span className="text-white/30 font-display text-lg">{String(i + 1).padStart(2, "0")}</span>
              <ArrowUpRight size={22} weight="bold" className="text-white/30 group-hover:text-primary group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300" />
            </div>
            <h3 className="font-display uppercase text-2xl md:text-3xl mt-10 group-hover:text-primary transition-colors">
              {m.name}
            </h3>
            <p className="text-white/50 text-sm mt-3">{m.tag}</p>
          </a>
        </FadeIn>
      ))}
    </div>
  </section>
);
